import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ColDef } from 'ag-grid-community';
import { CommonService } from 'src/app/services/common.service';
import { ToggledependencyComponent } from '../toggledependency/toggledependency.component';
import { EditbuttonrenderComponent } from '../editbuttonrender/editbuttonrender.component';
import { CellRendererComponent } from 'ag-grid-community/dist/lib/components/framework/componentTypes';
import { MatDialog } from '@angular/material/dialog';
import { DynamicpopupComponent } from '../dynamicpopup/dynamicpopup.component';
import { event, param } from 'jquery';
let vm: any;
@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  documenttypedropdown: any = [];
  documenttypedropdown1: any = [];
  visibilityList: any = [];
  visibilityList1: any = [];
  updatedData: String = "";
  page = {
    homepage: true,
    definedoctype: false,
    uploaddoc: false
  };
  documentform: FormGroup
  overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
  overlayNoRowsTemplate = '<span class="ag-overlay-no-rows-center">No data available</span>';
  rowSelection = 'multiple';
  rowHeight = 30;
  gridApi: any;
  gridColumnApi: any;
  tooltipShowDelay = 0;
  frameworkComponents = {
    editButtonRederer: EditbuttonrenderComponent,
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.gridApi.sizeColumnsToFit();

  }
  constructor(private commonServ: CommonService, private fb: FormBuilder, private dialog: MatDialog) {

    this.documentform = this.fb.group({
      documenttype: [""],
      visibility: [""],



    });
  }
  onCellClicked(item) { }

  ngOnInit(): void {
    vm = this;
    this.getdocuemnttype();
    this.getdocumentvisbility();
    this.fetchDocumenttypetabledata();
  }
  onTenantSelect(e) {

  }
  defaultColDef: ColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    minWidth: 110
  };
  rowData = [];
  columnDefs: any = [
    {
      headerName: "Doc ID", field: "doc_id", headerTooltip: "Doc ID", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Doc Type", field: "doc_type", headerTooltip: "Doc Type", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Doc Name", field: "doc_name", headerTooltip: "Doc Name", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Version", field: "doc_version", headerTooltip: "Version", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Visibility", field: "visibility", headerTooltip: "Visibility", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Description", field: "doc_description", headerTooltip: "Description", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    },
    {
      headerName: "Tenant ID", field: "tenant_id", headerTooltip: "Tenant ID", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Uploaded On", field: "uploaded_on", headerTooltip: "Uploaded On", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,

      },
    }
    , {
      headerName: "Status", field: "enabled_flag", headerTooltip: "Status", pinned: 'right',
      cellRendererFramework: ToggledependencyComponent
    }
    , {
      headerName: "Edit", field: "edit", headerTooltip: "Edit", pinned: 'right', cellRenderer: 'editButtonRederer',

      cellRendererParams: {
        clicked: function (params: any) {
          console.log("params", params)
          vm.openEditpop(params.data);
        },
      }
    },
    {
      headerName: "Logs", field: "logs", headerTooltip: "Logs", filterParams: {
        buttons: ['apply', 'reset'],
        closeOnApply: true,
      },
    }

  ]
  getdocuemnttype() {
    this.commonServ.fetchDocumentType().subscribe((response) => {
      console.log(response)
      this.documenttypedropdown = response;
      this.documenttypedropdown1 = this.documenttypedropdown.slice()
    })
  }
  getdocumentvisbility() {
    this.commonServ.fetchDocumentVisibility().subscribe((response) => {
      console.log(response)
      this.visibilityList = response;
      this.visibilityList1 = this.visibilityList.slice();

    })
  }

  fetchDocumenttypetabledata() {
    this.commonServ.fetchDocumenttableData().subscribe((response) => {
      console.log(response)
      this.rowData = response
    })
  }
  valuedoctype: any
  onViewValueChange(e) {
    // console.log("event",e)
    this.valuedoctype = ""
    this.rowData = []
    this.filterrowdata = []
    this.commonServ.fetchDocumenttableData().subscribe((response) => {
      console.log(response)
      // this.rowData=response
      for (let item of response) {
        if (item.visibility == e['visibility']) {
          this.filterrowdata.push({
            doc_description: item.doc_description, tenant_id: item.tenant_id, doc_id: item.doc_id, doc_name: item.doc_name,
            doc_type: item.doc_type, doc_version: item.doc_version, enabled_flag: item.enabled_flag, uploaded_on: item.uploaded_on,
            logs: item.logs, visibility: item.visibility
          })
        }
      }
      console.log(this.filterrowdata)
      this.rowData = this.filterrowdata
    })

  }

  openEditpop(row: any) {
    console.log('editpop', row)
    const dialogRef = this.dialog.open(DynamicpopupComponent, {
      width: '100%',
      // data: params,
      disableClose: true,
      data: {
        header: 'Edit document Data',
        type: 'editdocumentdata',
        param: row
      },
      panelClass: 'my-dialog',
    });
    dialogRef.afterClosed().subscribe(data => {
      this.ngOnInit()
      if (data) {
      }
    });
  }


  isDetailsPage(page: string) {
    // this.page[page] = true
    return this.page[page];
  }

  opendefinedocpop() {
    this.page = {
      homepage: false,
      definedoctype: true,
      uploaddoc: false
    };
  }

  openuploaddocpop() {
    this.page = {
      homepage: false,
      definedoctype: false,
      uploaddoc: true
    };
  }
  onBack(event) {
    this.page = {
      homepage: true,
      definedoctype: false,
      uploaddoc: false
    };
  }

  onbackchild(event) {
    // console.log(event)
    this.page = event
  }
  visibityvaluefromdocumenttype: any
  filterrowdata: any = []

  // documentLogs(e, event){
  //   this.commonServ.fetchDocumenttableData().subscribe((response)=>{
  //     for (let item of response) {
  //      this.updatedData="Last updated by" + item.crea 
  //     }
  //   }
  //   )
  // }

  onDocumentSelect(e, event) {
    this.rowData = []
    this.filterrowdata = []
    console.log("event", e)

    this.commonServ.fetchVisibility(e).subscribe((response) => {
      console.log("response", response)
      this.visibityvaluefromdocumenttype = response[0]['visibility']

      event['visibility'] = response[0]['visibility']
      console.log("event", event)
      this.commonServ.fetchDocumenttableData().subscribe((response) => {
        console.log(response)
        // this.rowData=response
        for (let item of response) {
          if (item.doc_type == event['documenttype']) {
            this.filterrowdata.push({
              doc_description: item.doc_description, tenant_id: item.tenant_id, doc_id: item.doc_id, doc_name: item.doc_name,
              doc_type: item.doc_type, doc_version: item.doc_version, enabled_flag: item.enabled_flag, uploaded_on: item.uploaded_on,
              logs: item.logs, visibility: item.visibility
            })
          }
        }
        console.log(this.filterrowdata)
        this.rowData = this.filterrowdata
      })

    })
  }

}
